import React, { Component } from "react";
import { connect } from "react-redux";
import { USER_DETAILS } from "../../../store/queries.js";
import { Query } from "react-apollo";
import cookie from "js-cookie";
import Form from "./Form.js";
import { updateUser } from "../../../store/redux/actions";
import { Honeybadger } from "@honeybadger-io/react";

class MemberProfile extends Component {
  constructor(props) {
    super(props);
    this._loggedErrors = {};
  }

  getUserIdFromUrl() {
    const params = new URLSearchParams(this.props.location?.search);
    return params.get("userId");
  }

  componentDidMount() {
    if (!this.props.global?.currentUser?.selectedUser) {
      const userIdFromUrl = this.getUserIdFromUrl();
      if (userIdFromUrl) {
        this.props.updateUser({ selectedUser: userIdFromUrl });
      }
    }
  }

  logToHoneybadger(errorType, additionalContext = {}) {
    if (this._loggedErrors[errorType]) return;
    this._loggedErrors[errorType] = true;

    const { global, location, history } = this.props;
    Honeybadger.notify({
      name: "MemberProfile Error",
      message: errorType,
      context: {
        errorType,
        selectedUser: global?.currentUser?.selectedUser,
        currentUserId: global?.currentUser?.id,
        currentUserType: global?.currentUser?.type,
        currentUserEmail: global?.currentUser?.email,
        currentUserPark: global?.currentUser?.park,
        pathname: location?.pathname,
        search: location?.search,
        historyState: history?.location?.state,
        referrer: document.referrer,
        timestamp: new Date().toISOString(),
        ...additionalContext
      }
    });
  }

  render() {
    const selectedUser =
      this.props.global?.currentUser?.selectedUser || this.getUserIdFromUrl();

    if (!selectedUser) {
      this.logToHoneybadger("selectedUser is missing", {
        globalState: JSON.stringify(this.props.global)
      });
      const userType = this.props.global?.currentUser?.type;
      if (userType === "Employee") {
        this.props.history.replace("/dashboard");
      } else if (userType === "Manager" || userType === "Admin") {
        this.props.history.replace("/manager/members");
      } else {
        this.props.history.replace("/");
      }
      return null;
    }

    return (
      <Query
        fetchPolicy="no-cache"
        query={USER_DETAILS}
        variables={{ id: selectedUser }}
      >
        {({ loading, error, data, refetch }) => {
          if (loading) return null;
          if (error) {
            if (
              error.message ===
              "GraphQL error: You are not authorized to access that resource"
            ) {
              cookie.remove("token");
              this.props.updateUser("reset");
              this.props.history.push("/login");
            }
            return `Error: ${error.message}`;
          }
          if (!data || !data.userDetail) {
            this.logToHoneybadger("data.userDetail is undefined", {
              dataReceived: JSON.stringify(data),
              selectedUserValue: selectedUser
            });
            return "Error: Member not found";
          }
          return <Form refetch={refetch} initialValues={data.userDetail} />;
        }}
      </Query>
    );
  }
}
const mapStateToProps = state => ({ ...state.global });
const mapDispatchToProps = { updateUser };

export default connect(mapStateToProps, mapDispatchToProps)(MemberProfile);
